import React from 'react';
export default function VisualStatePlaceholder() {
    return (<div>
        Enter visual state, for example:
        <br />
        <br />
        <div>
            {'{'} <br />
            {'  "field1": ...,'} <br />
            {'  "field2": ...,'} <br />
            {'  ...,'} <br />
            {'}'} <br />
        </div>
    </div>);
}
